import { Popper } from "@mui/material";
import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import {
  textFieldTypographyH4Medium,
  textFieldTypographyH4Regular,
  textFieldTypographyH5SemiBold,
} from "../typography/MuiTypography.style";

export const MuiAutoCompleteWrapper = styled.div`
  border-radius: 8px;
  margin-top: 5px;

  ${responsive.MOBILE`
    margin-top: 0;
  `}

  .title {
    display: flex;
    align-items: baseline;
  }

  .MuiAutocomplete-popupIndicator {
    display: none;
  }

  .mui-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black7};
    }
  }
  .asterisk {
    color: ${COLORS.cirrus_red};
  }

  .textbox-auto-complete {
    ${textFieldTypographyH4Regular}
    color: ${COLORS.cirrus_black};
    .MuiInputBase-input {
      color: ${COLORS.cirrus_black};

      &::placeholder {
        color: ${COLORS.cirrus_black5};
        opacity: 1;
      }
    }

    .MuiOutlinedInput-root {
      border-radius: 8px;
      height: 48px;
      background-color: ${COLORS.cirrus_black1};
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_black};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_black};
        border-width: 1px;
      }

      &.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
        border-width: 2px;
      }

      &:hover.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
      }
      .Mui-disabled {
        -webkit-text-fill-color: ${COLORS.cirrus_black7};
      }
    }
  }

  .MuiInputBase-root .MuiInputAdornment-positionEnd {
    width: 24px;
    height: 24px;

    & > svg {
      cursor: pointer;
    }
  }

  .MuiInputBase-input {
    ${textFieldTypographyH4Medium}
    padding: 11px 16px;
    line-height: 18px;

    &::placeholder {
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiFormHelperText-root {
    ${textFieldTypographyH5SemiBold}
    margin-top: 8px;
    line-height: 14px;
    color: ${COLORS.cirrus_red};
    display: flex;
  }

  .Mui-error {
    margin-left: 0px;
    border-width: 1px;
    border-radius: 8px;
    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.cirrus_red};
      border-width: 2px;
    }
  }

  .info-box {
    display: flex;
    flex-direction: row;
    background-color: ${COLORS.cirrus_white};

    .error-icon {
      display: flex;
      flex-direction: row;
      flex: 90%;
      word-break: break-word;
    }
  }
  .MuiInputBase-root.Mui-disabled {
    .MuiOutlinedInput-notchedOutline,
    fieldset {
      border-color: ${COLORS.cirrus_black2} !important;
      pointer-events: none;
    }
  }

  .Mui-disabled {
    &::placeholder {
      -webkit-text-fill-color: ${COLORS.cirrus_black5};
    }
  }
  .label-option {
    color: ${COLORS.cirrus_black};
  }
`;

export const StyledAutoCompletePopper = styled(Popper)`
  .MuiAutocomplete-paper {
    margin-top: 5px;
    border: 1px solid ${COLORS.cirrus_black5};
    border-radius: 8px;
    color: ${COLORS.cirrus_black};

    .MuiAutocomplete-option {
      ${textFieldTypographyH4Medium}
      padding: 12px 16px;

      &[aria-selected="true"] {
        background-color: ${COLORS.cirrus_black1};
      }

      &.Mui-focused {
        background-color: ${COLORS.cirrus_black2};
      }
    }

    .MuiAutocomplete-noOptions {
      ${textFieldTypographyH4Medium}
      text-align: center;
      color: ${COLORS.cirrus_black};
    }
  }

  .tooltip-container {
    position: relative;
  }

  .tooltip-wrapper {
    position: absolute;
    bottom: 2px;
  }
`;
